/* eslint-disable @typescript-eslint/no-explicit-any */
import { HorseRank } from 'models'
import { shortenRaceNameV2 } from 'utils/helper'
import { constants } from 'apps'
import { useAppDispatch, useLocalStorage } from 'hooks'
import { checkExistItem } from 'features/Horse/components/HorseItem/utils'
import VipIcon from 'features/components/VipIcon'
import MemoizedLoadImageCommon from 'shared/MemoizedImage/LoadImageCommon'
import MyHorseItemStyled from './styled'
import { getImageGender, getImageRegion } from 'utils/getLinkImage'
import { ClassTag } from 'shared'
import { NUMBER, STRING } from 'apps/constants'
import { convertFullDate, convertShortTimeMinus } from 'utils/time'
import { updateStateModal } from 'features/Profile/profile.slice'

interface MyHorseItemProps {
  horse: HorseRank
}

const typeRuntype = 'RUNTYPE'
const typeChar = 'CHARACTERISTIC'
const typeAll = 'CHARACTERISTIC_RUNTYPE'
const glassUrl = '/_horse/_avatar/_glass/g_'
const shoesUrl = '/_horse/_avatar/_shoes/sh_'
const armorUrl = '/_horse/_avatar/_armor/'
const skinUrl = '/_horse/_avatar/_skin/'
const domain = process.env.REACT_APP_ROOT_DOMAIN

function HorseNewRecord({ horse }: MyHorseItemProps) {
  const [userId] = useLocalStorage(constants.USER_ID_KEY, 0)
  const converToUtf8 = (value: string) => {
    return value.replace('#', '%23')
  }
  const dispatch = useAppDispatch()
  const horseColorCode = converToUtf8(horse?.bloodline?.color_code || horse?.blood_line?.color_code || '')
  
  const weapon = horse?.weapon_items_equipped
  const headItem = checkExistItem('HEAD', weapon)
  const bodyItem = checkExistItem('BODY', weapon)
  const footItem = checkExistItem('LEG', weapon)
  const skinItem = checkExistItem('SKIN', weapon)
  const fullURLGlass = horse?.characteristic ? `${domain}${glassUrl}${horse?.characteristic}.png` : `${domain}${glassUrl}char_01.png`
  const fullURLShoes = horse?.run_type ? `${domain}${shoesUrl}${horse?.run_type}.png` : `${domain}${shoesUrl}rt_01.png`
  const typeOfMaterial = bodyItem?.material_type?.toUpperCase()

  const fullURLBody = (typeOfMaterial: any) => {
    switch (typeOfMaterial) {
      case typeRuntype: {
        return domain + armorUrl + bodyItem?.model_name + '_' + horse?.run_type + '.png'
      }
      case typeChar: {
        return domain + armorUrl + bodyItem?.model_name + '_' + horse?.characteristic + '.png'
      }
      case typeAll: {
        return domain + armorUrl + bodyItem?.model_name + '_' + horse?.characteristic + '_' + horse?.run_type + '.png'
      }
      default:
        return domain + armorUrl + bodyItem?.model_name + '.png'
    }
  }

  const headtUrl = domain + armorUrl + headItem?.model_name + '_' + horse?.characteristic + '.png'

  const footUrl = domain + armorUrl + footItem?.model_name + '_' + horse?.run_type + '.png'

  const fullSkinUrl = (hairColor: any) => {
    switch (hairColor) {
      case 'SAME_BODY': {
        return domain + skinUrl + skinItem?.model_name + '_' + horse?.hair_color + '_' + horseColorCode + '.png'
      }
      default:
        return domain + skinUrl + skinItem?.model_name + '_' + horse?.hair_color + '.png'
    }
  }

  const handleFieldType = (field: string) => {
    if (field === STRING.TURF) {
      return <span className='font-bold color-turf-field'>{field}</span>
    } else {
      return <span className='font-bold color-orange'>{field}</span>
    }
  }

  const showModalUser = () => {
    if (horse?.owner_id) {
      dispatch(updateStateModal({
        isOpen: true,
        userId: horse?.owner_id,
      }))
    }
  }

  return (
    <MyHorseItemStyled mySelf={userId === horse?.owner_id}>
      <td className='color-white width-30 horse-name left'>
        <div className='horse-name-content'>
          <div className='background d-flex align-items-center justify-content-center'>
            <img src={horse?.horse_avatar} alt='list-horse' className='avatar' />

            {headItem && headItem?.model_name
              ? <img src={headtUrl} alt={headItem.name} className='item head' /> 
                : <img src={fullURLGlass} className="item glass" /> }

            {bodyItem && bodyItem?.model_name && <img src={fullURLBody(typeOfMaterial)} alt={bodyItem.name} className='item body' />}
      
            {footItem && footItem?.model_name
              ? <img src={footUrl} alt={footItem.name} className='item foot' />
              : <img src={fullURLShoes} className="item shoes" /> }

            {skinItem && skinItem?.model_name && <img src={fullSkinUrl(horse?.hair_color)} alt={skinItem.name} className='item skin' />}
          </div>
          {/* <img src={horse?.horse_avatar} alt='list-horse' className='horse-avatar' /> */}
          <span className="horse__name">
            {shortenRaceNameV2(horse?.horse_name, 18)}
          </span>
        </div>
      </td>
      <td className='width-3'>
        <span className='horse-gender'>
          <MemoizedLoadImageCommon srcImg={getImageGender(horse?.gender)} />
        </span>
      </td>
      <td className='width-3'>
        <span className='region'>
          <MemoizedLoadImageCommon srcImg={getImageRegion(horse?.region) } />
        </span>
      </td>
      <td className='width-3'>
        <div className='vip__pass'>
          {horse?.vip_pass && <VipIcon />}
        </div>
      </td>

      <td className='color-white width-8 left'>
        <ClassTag text={horse?.new_record_info?.race_class} isActive={true} />
      </td>

      <td className='color-white width-8 left'>
        <span>
          { handleFieldType(horse?.new_record_info?.field_type) }
        </span>
      </td>

      <td className='color-white width-8 left'>
        <span className='font-bold'>
          {horse?.new_record_info?.distance ? `${horse?.new_record_info?.distance?.toLocaleString()}m` : '0m'}
        </span>
      </td>

      <td className='color-white width-12 left'>
        <span className='font-bold'>
          { convertShortTimeMinus(horse?.new_record_info?.race_time) }
        </span>
      </td>

      <td className='color-white width-12 left'>
        <span className='font-bold'>
          {convertFullDate(horse?.new_record_info?.record_date * NUMBER.THOUSAND)}
        </span>
      </td>

      <td className='color-white width-13 left owner'>
        <span onClick={showModalUser}>{shortenRaceNameV2(horse?.owner, 18)}</span>
      </td>
    </MyHorseItemStyled>
  )
}

export default HorseNewRecord
